import { useEffect, useState, useContext} from "react";
import {Container} from "react-bootstrap";
import {userLoginKey} from "../config";
import Logo from '../assets/img/logo60.png'
import GlobalState from "../context/MenuSelect";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Menu = () => {
  const [userLogin, setUserLogin] = useState(false)
  const {loginContext } = useContext(GlobalState)


  useEffect(() => {
    if (sessionStorage.getItem(userLoginKey)) {
      setUserLogin(true)
    }


  }, [loginContext])


  const scrollHandle = (e) => {
    e.preventDefault();
    const id = e.target.id;
    const position = document.getElementById(id.slice(0, id.length - 1)); //removing extra last - (dash)
    window.location.href = "/#" + id.slice(0, id.length - 1); // changing the url
    position && position.scrollIntoView({ behavior: "smooth", block: "start" }) //scrolling the page
  }


  return (
    <Container id="header">
      <Row>
        <Col xl={6} lg={3}>
          <div className="container">
            <a className="sr-only text-nowrap" href="#aC" pagescroll="" tabIndex="1"
               title="跳到主要內容區塊">跳到主要內容區塊</a>
          </div>
          <div className="container d-flex align-items-center justify-content-between">
            <h1 className="logo" title="金融監督管理委會員檢查局e化金檢知識網">
                  <a href="/" title="回到e化金檢知識網首頁" tabIndex="1">
                    <img src={Logo} alt="金融監督管理委會員檢查局" className="logo-mobile"/>
                    <span className="title-mobile text-nowrap">&nbsp;<strong>e</strong>化金檢知識網</span>
                  </a>
            </h1>
          </div>
        </Col>
        <Col className="d-flex align-items-center justify-content-end">
          <nav id="navbar" className="navbar">
            <ul>
              <li><a className="accesskey" href="#aU" id="aU" accessKey="U" title="上方功能區塊" tabIndex="1">:::</a></li>
              <li><a className="nav-link scrollto" role="menuitem" tabIndex="1" onClick={scrollHandle} id="about-" title="回到首頁" href="">回首頁</a></li>
              {userLogin ?<li><a className="nav-link scrollto" role="menuitem" tabIndex="1" href="/classFirst" title="前往課程列表">課程列表</a></li>: null}
              <li><a className="nav-link scrollto" role="menuitem" tabIndex="1" href="/sitemap" title="前往網站導覽頁">網站導覽</a></li>
              <li><a className="nav-link scrollto" role="menuitem" tabIndex="1" title="前往意見區" href="/sectionSuggestion">意見區</a></li>

              {userLogin ? null:  <li><a className="getstarted scrollto" tabIndex="1" onClick={scrollHandle} id="services-" title="進入課程" href="">進入課程</a></li>}
            </ul>

          </nav>
        </Col>
      </Row>
    </Container>
  );
};

export default Menu;
